import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react';

import { Modal, ModalFooter, ModalBody, ModalHeader } from 'reactstrap';

import { Form } from '@unform/web';
import { ReactComponent as AlertIcon } from '../../assets/img/alert-orange-icon.svg';
import { toast } from 'react-hot-toast';
import * as Yup from 'yup';
import {
  format,
  endOfDay,
  subHours,
  addHours,
  differenceInHours,
  getDay,
  getHours,
  differenceInMonths,
  getMinutes,
} from 'date-fns';
import {
  Modal as TakeatModal,
  Button as TakeatButton,
} from 'takeat-design-system-ui-kit';
import { ReactComponent as LiveIcon } from '~/assets/img/liveIcon.svg';
import { FaExclamationTriangle } from 'react-icons/fa';
import { FiCopy } from 'react-icons/fi';
import { toJpeg } from 'html-to-image';
import ImgToPrint from '~/components/ImgToPrint';
import ButtonDefault from '~/components/Buttons/DefaultButton';
import Input from '~/components/Form/Input';
import formatCompleteDate from '~/services/formatCompleteDate';
import pixLogo from '~/assets/img/pix_logo.png';
import { ReactComponent as LiveOn } from '~/assets/img/live_on.svg';
import { ReactComponent as LiveOff } from '~/assets/img/live_off.svg';

import { useOrder } from '~/context/orderContext';
import { useClosing } from '~/context/closingContext';
import { useTables } from '~/context/TablesContext';
import { useAuth } from '~/context/AuthContext';
import Textarea from '~/components/Form/Textarea';
import { default as api } from '~/services/api2';
import OrdersOperation from '~/components/Operation/OrdersOperation';
import TablesOperation from '~/components/Operation/TablesOperation';
import getValidationErrors from '~/services/getValidationErrors';
import PersonalButton from '~/components/Buttons/PersonalButton';
import { useMenu } from '~/context/OrderingSystem/Menu';
import { useWaiterTickets } from '~/context/WaiterTicketContext';

import history from '~/services/history';
import { Button, Tabs } from 'ui-kit-takeat';
import { Button as ButtonUi } from 'takeat-design-system-ui-kit';
import PermissionErrorContainer from '~/components/PermissionErrorContainer';
import { NewHeader } from '~/components/NewHeader';
import BannerErrorWpp from '~/assets/img/erroWpp.jpeg';
import { FaX } from 'react-icons/fa6';
import Warning from '~/components/Notify';

import {
  Wrapper,
  OperationArea,
  TablesCardArea,
  OrdersCardArea,
  Table,
  SaveButton,
  RatingContent,
  RatingHeader,
  RatingBody,
  TablesContainer,
  LiveTextContent,
  BalconyLink,
  TakeatModalHeader,
  TakeatModalBody,
  TakeatModalFooter,
} from './styles';
import WhatsappConnectionModal from '~/components/WppReconnectModal';
import WaiterDeliveryAlertWppModal from 'components/WaiterDeliveryAlertWppModal';
import useWppAlert from 'hooks/wppAlert';
import WaiterAlertWppDesign from 'components/WaiterDeliveryAlertWppModal/WaiterAlertWppDesign';
import { WaiterAlertWppDesignContainerFixedPosition } from 'components/WaiterDeliveryAlertWppModal/WaiterAlertWppDesign/styles';
import WaiterHelpModal from 'components/WaiterHelpModal';
import ModalUpdateZoop from 'components/ModalUpdateZoop';
import useWhatsappStore from 'store/whatsappStore';
import { TaxReform2026Component } from 'components/TaxReform2026Component';
import { handleWhatsappIndicator } from '~/utils/handleWhatsappIndicator';
import { LoadingPage } from 'components/LoadingPage';

// import { ModalDeliveryCover } from 'components/ModalDeliveryCover';
// import NfceModal from 'components/NfceModal';

function Operation() {
  const {
    signOut,
    user,
    token,
    setData,
    modalNpsCloseTime,
    setModalNpsCloseTime,
    userAlreadyRate,
    setUserAlreadyRate,
    handleOpenAsaas,
    shouldFetchOperation,
    setShouldFetchOperation,
    hasOverdueUrl,
    websocketManager,
  } = useAuth();
  const { planType } = useWhatsappStore();
  const setWppFailedMessage = useWhatsappStore(
    (state) => state.setWppFailedMessage
  );
  const [minimalSessions, setMinimalSessions] = useState([]);
  const [minimalSessionsOld, setMinimalSessionsOld] = useState([]);
  const [orderBasketId, setOrderBasketId] = useState();
  const [deliveryOpened, setDeliveryOpened] = useState(false);
  const [withdrawalOpened, setWithdrawalOpened] = useState(false);
  const [newsRead, setNewsRead] = useState(
    JSON.parse(localStorage.getItem('@gddashboard:newsRead'))
  );

  const [clubIsLogged, setClubIsLogged] = useState(false);
  const [clubToken, setClubToken] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const { getMenu } = useMenu();
  const { waiterTickets } = useWaiterTickets();

  const [count, setCount] = useState('');

  const cancelForm = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    if (shouldFetchOperation) {
      setShouldFetchOperation(false);
      handleUpdate();
      toast.success('Operação atualizada!');
    }
  }, [shouldFetchOperation]);

  const downloadPng = useCallback(() => {
    if (imgRef.current === null) {
      return;
    }

    toJpeg(imgRef.current, { cacheBust: true, fontEmbedCSS: false })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'cardapio_digital_takeat.jpg';
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  }, [imgRef]);

  const { tablesAvailable, getTablesAvailable, tableMenu } = useTables();

  const [tablesFilteredSearch, setTablesFilteredSearch] = useState([]);
  const [allTables, setAllTables] = useState([]);
  const [allTablesAvailable, setAllTablesAvailable] = useState(tablesAvailable);

  const [isModalSystemBloquedOpen, setIsModalSystemBloqued] = useState(false);

  const [fromState, setFromState] = useState();
  const [codeCopyed, setCodeCopyed] = useState(false);

  const hasKey = user ? user.has_order_cancel_password : false;

  const [modalCancelOrderIsOpened, setModalCancelOrderIsOpened] =
    useState(false);

  function toggleModalSystemBloqued() {
    setIsModalSystemBloqued(!isModalSystemBloquedOpen);
  }

  function handleOpenCancelOrderModal(order_basket_id, from) {
    setModalCancelOrderIsOpened(true);
    setOrderBasketId(order_basket_id);
    setFromState(from);
  }

  const toggleModalCancelOrder = useCallback(() => {
    setModalCancelOrderIsOpened(!modalCancelOrderIsOpened);
  }, [modalCancelOrderIsOpened]);

  const orderOperationRef = useRef(null);
  const tablesRef = useRef(null);

  const setInputValueTables = useCallback(() => {
    tablesRef.current.setInput();
  }, []);

  const [modalPix, setModalPix] = useState(false);

  function toggleModalPix() {
    setModalPix(!modalPix);
  }

  const {
    pendingBaskets,
    acceptedBaskets,
    finishedBaskets,
    canceledBaskets,
    loading,
    setLoading,
    getAllOrders,
    setUpdateTime,
    updateTime,
    moveOrderToAccepted,
    moveOrderToFinished,
    moveOrderToCanceled,
    pixToShow,
    allPix,
    getPixPayments,
    ifoodClosedMessage,
    sessionsInCache,
    setSessionsInCache,
  } = useOrder();

  const {
    closingIndividualBills,
    closingTableBills,
    getClosingIndividualBills,
    getClosingTableBills,
    printIndividualBill,
    printTableBill,
    printQueueTable,
  } = useClosing();

  const wppAlert = useWppAlert();

  const [localPixToShow, setLocalPixToShow] = useState([]);

  useEffect(() => {
    setIsModalSystemBloqued(!user.is_active && hasOverdueUrl);
  }, [user.is_active, hasOverdueUrl]);

  const [lastNumber, setLastNumber] = useState('');

  const handleSearchInputTables = useCallback(
    (e) => {
      try {
        const tableNumber = e;

        setLastNumber(e);

        if (minimalSessions.length < 1) {
          setMinimalSessions(minimalSessionsOld);
        }

        const tableFind = allTables.filter((table) => {
          if (table?.table_number?.toString().startsWith(tableNumber)) {
            return table;
          }
          return '';
        });

        const tableOccpuiedFind = allTables.filter((table) => {
          if (table?.table?.table_number?.toString().startsWith(tableNumber)) {
            return table;
          }
          return '';
        });

        const tableAvailableFind = tablesAvailable.filter((table) => {
          if (table?.table_number?.toString().startsWith(tableNumber)) {
            return table;
          }
          return '';
        });

        if (tableAvailableFind.length > 0) {
          setAllTablesAvailable(tableAvailableFind);
        } else {
          setAllTablesAvailable([
            {
              status: 'none',
              id: 'abc124s',
            },
          ]);
        }

        if (tableFind.length > 0 || tableOccpuiedFind.length > 0) {
          setTablesFilteredSearch([...tableOccpuiedFind, ...tableFind]);
        } else {
          setTablesFilteredSearch([
            {
              status: 'none',
              id: 'abc124s',
            },
          ]);
        }

        if (!tableNumber) {
          setTablesFilteredSearch('');
          setAllTablesAvailable('');
        }
      } catch (error) {
        toast.error(`Produto não encontrado!`);
      }
    },
    [minimalSessions, tablesAvailable, minimalSessionsOld]
  );

  const handlePrintItem = useCallback(
    async (id) => {
      try {
        await api.put(`restaurants/orders/${id}`, {
          order_status: 'accepted',
        });
        moveOrderToAccepted({ order_basket_id: id });
        toast.success('Pedido aceito!');
      } catch (err) {
        toast.error('Não foi possível atualizar o pedido! tente novamente');
      }
    },
    [moveOrderToAccepted]
  );

  const handleItemFinished = useCallback(
    async (id) => {
      try {
        const response = await api.put(`restaurants/orders/${id}`, {
          order_status: 'finished',
        });

        handleWhatsappIndicator(response.data?.whatsappIndicator);

        moveOrderToFinished({ order_basket_id: id });
        toast.success('Pedido entregue!');
      } catch (err) {
        toast.error('Não foi possível atualizar o pedido! tente novamente');
      }
    },
    [moveOrderToFinished]
  );

  const [loadingCancelItem, setLoadingCancelItem] = useState(false);

  const handleCancelItemModal = useCallback(
    async (data) => {
      setLoadingCancelItem(true);
      try {
        if (cancelForm?.current) {
          cancelForm.current.setErrors({});
        }

        const schema = Yup.object().shape({
          order_cancel_password: Yup.string().required('senha obrigatória'),
          cancel_reason: Yup.string().required('justicativa obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
        await api.put(`restaurants/orders/cancel/${orderBasketId}`, {
          order_cancel_password: data.order_cancel_password,
          cancel_reason: data.cancel_reason,
        });
        moveOrderToCanceled({
          order_basket_id: orderBasketId,
          from: fromState,
        });
        toggleModalCancelOrder();
        handleSearchInputTables(lastNumber);
        toast.success('Pedido cancelado!');
        setLoadingCancelItem(false);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          if (cancelForm?.current) {
            cancelForm.current.setErrors(errors);
          }
        } else if (
          error.response.data?.err?.errorType ===
          'incorrect_order_cancel_password'
        ) {
          toast.error('senha incorreta');
        } else {
          toast.error('Erro ao cancelar pedido!');
        }
        setLoadingCancelItem(false);
      }
    },
    [
      fromState,
      handleSearchInputTables,
      lastNumber,
      orderBasketId,
      moveOrderToCanceled,
      toggleModalCancelOrder,
      setLoadingCancelItem,
    ]
  );

  const handleCancelItem = useCallback(
    async ({ order_basket_id, from }) => {
      try {
        if (hasKey) {
          handleOpenCancelOrderModal(order_basket_id, from);
          handleSearchInputTables(lastNumber);
        } else if (
          window.confirm('Tem certeza que deseja cancelar este pedido?')
        ) {
          await api.put(`restaurants/orders/cancel/${order_basket_id}`);
          moveOrderToCanceled({ order_basket_id, from });
          toast.success('Pedido cancelado!');
        }
      } catch (err) {
        toast.error('Não foi possível atualizar o pedido! tente novamente');
      }
    },
    [handleSearchInputTables, lastNumber, hasKey, moveOrderToCanceled]
  );

  // Comandas

  const defaultFinal = useMemo(() => {
    return endOfDay(new Date()).toISOString();
  }, []);

  const defaultInicial = useMemo(() => {
    return subHours(new Date(), 12).toISOString();
  }, []);

  const [inicialDate, setInicialDate] = useState(defaultInicial);
  const [finalDate, setFinalDate] = useState(defaultFinal);
  const [opened, setOpened] = useState(user.opened);

  const [sessions, setSessions] = useState([]);
  const [isModalQrcodeOpened, setIsModalQrcodeOpened] = useState(false);
  const toggleModalQrcode = () => {
    setIsModalQrcodeOpened(!isModalQrcodeOpened);
    setCodeCopyed(false);
  };

  const isBalconyPinpad = user.user_use_pinpad && user.use_pinpad;

  const getMinimalSessions = useCallback(async () => {
    try {
      const final = endOfDay(new Date()).toISOString();
      const inicial = subHours(new Date(), 12).toISOString();

      const response = await api.get('/restaurants/table-sessions-minimal', {
        params: {
          start_date: `${inicial}`,
          end_date: `${final}`,
          isBalconyPinpad: user.use_pinpad,
        },
      });

      const sessionsOrder = response.data.sort((a, b) => {
        if (a.table.table_type[0] === b.table.table_type[0]) {
          return a.table.table_number - b.table.table_number;
        }
        return a.table.table_type[0] === 'b' ? -1 : 1;
      });

      // salvando em cache para resumo de comandas
      const openSessions = response.data.filter(
        (data) =>
          (data.status === 'open' || data.status === 'closing') &&
          data.is_delivery === false
      );
      let sessionsInCache = openSessions?.map((session) => {
        const paid = session.payments.reduce(
          (acc, pay) => acc + parseFloat(pay.payment_value),
          0
        );

        return {
          id: session.id,
          table_number: session.table.table_number,
          start_time: session.start_time,
          paid,
          bills: [],
          status: session.status,
          total_price: session.total_price,
          total_service_price: session.total_service_price,
        };
      });

      sessionsInCache = sessionsInCache.sort((a, b) => {
        return a.table_number - b.table_number;
      });

      const toCache = {
        updated_at: new Date(),
        sessions: sessionsInCache,
      };

      setSessionsInCache(toCache);
      localStorage.setItem(
        '@gddashboard:sessionsInCache',
        JSON.stringify(toCache)
      );

      setMinimalSessions(sessionsOrder);
      setAllTables(sessionsOrder);
      // getTablesAvailable();
    } catch (err) {
      if (!err?.response?.ok) {
        if (err?.response?.data?.errorType === 'invalid_token') {
          window.location.reload();
          signOut();
        }

        if (err?.response?.data?.errorType === 'token_not_sent') {
          signOut();
        }
      }
      toast.error('Erro ao carregar informações');
    }
  }, [finalDate, inicialDate, signOut]);

  useEffect(() => {
    setAllTablesAvailable(tablesAvailable);
  }, [tablesAvailable]);

  // useEffect(() => {
  //   getSessions();
  // }, [pendingBaskets, acceptedBaskets, getSessions]);

  const handleUpdate = useCallback(async () => {
    setLoading(true);
    getMinimalSessions();
    getAllOrders();
    getClosingIndividualBills();
    getClosingTableBills();
    // getPayments();
    setLoading(false);
    getTablesAvailable();
    setAllTablesAvailable('');

    const nowTime = format(new Date(), 'HH:mm');
    setUpdateTime(nowTime);
  }, [
    getMinimalSessions,
    getAllOrders,
    getClosingIndividualBills,
    getClosingTableBills,
    getTablesAvailable,
    setAllTablesAvailable,
  ]);

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const updateOpeninBoxOperation = useCallback(() => {
    orderOperationRef.current.updateOpeninBox();
  }, []);

  async function orderByTableNumber() {
    try {
      const response = await api.get('/restaurants/table-sessions-minimal', {
        params: {
          start_date: `${format(
            addHours(new Date(inicialDate), 3),
            "yyyy-MM-dd'T'HH:mm:ss"
          )}`,
          end_date: `${finalDate}`,
        },
      });

      const sessionsOrder = response.data.sort((a, b) => {
        if (a.table.table_type[0] === b.table.table_type[0]) {
          return a.table.table_number - b.table.table_number;
        }
        return a.table.table_type[0] === 'b' ? -1 : 1;
      });

      setMinimalSessions(sessionsOrder);
    } catch (err) {
      // console.log('setsessions', response.data, inicialDate, finalDate);
      toast.error('Erro ao carregar informações');
    }
  }

  const orderByTableDate = useCallback(async () => {
    try {
      const response = await api.get('/restaurants/table-sessions-minimal', {
        params: {
          start_date: `${format(
            addHours(new Date(inicialDate), 3),
            "yyyy-MM-dd'T'HH:mm:ss"
          )}`,
          end_date: `${finalDate}`,
        },
      });

      setMinimalSessions(response.data);
    } catch (err) {
      // console.log('setsessions', response.data, inicialDate, finalDate);
      toast.error('Erro ao carregar informações');
    }
  }, [inicialDate, finalDate]);

  async function handlePixNotification() {
    setModalPix(false);
    setLocalPixToShow([]);
  }

  useEffect(() => {
    const isMenuUpdated = localStorage.getItem('@gddashboard:isMenuUpdated');

    if (isMenuUpdated) {
      if (isMenuUpdated.toString() === 'true') {
        getMenu();

        localStorage.setItem('@gddashboard:isMenuUpdated', false);
      }
    }
  }, [getMenu]);

  useEffect(() => {
    if (pixToShow.length > 0 && user.has_pix) {
      const pixTo = pixToShow?.map((pix) => pix);
      localPixToShow.forEach((pix) => {
        !pixTo.includes(pix) && pixTo.push(pix);
      });
      setLocalPixToShow(pixTo);
      setModalPix(true);
    }
  }, [pixToShow, allPix, user]);

  useEffect(() => {
    setLoading(false);
  }, [setLoading]);

  useEffect(() => {
    if (user?.has_pix) {
      getPixPayments();
    }
  }, [getPixPayments, token]);

  useEffect(() => {
    getMinimalSessions();
  }, [getMinimalSessions, pendingBaskets, acceptedBaskets]);

  useEffect(() => {
    if (!!opened !== user.opened) {
      setOpened(user.opened);
    }

    const { is_delivery_active, is_withdrawal_active } = user?.delivery_info;

    if (!!deliveryOpened !== is_delivery_active) {
      setDeliveryOpened(is_delivery_active);
    }

    if (!!withdrawalOpened !== is_withdrawal_active) {
      setWithdrawalOpened(is_withdrawal_active);
    }
  }, [opened, user.delivery_info, deliveryOpened, withdrawalOpened, user]);

  const inputRef = useRef(null);
  const inputDeliveryRef = useRef(null);

  function copyUrlCode() {
    const textoCopiado = inputRef.current;
    textoCopiado.select();
    textoCopiado.setSelectionRange(0, 99999);
    document.execCommand('copy');

    setCodeCopyed(true);
  }

  function copyDeliveryUrlCode() {
    const textoCopiado = inputDeliveryRef.current;
    textoCopiado.select();
    textoCopiado.setSelectionRange(0, 99999);
    document.execCommand('copy');

    setCodeCopyed(true);
  }

  const tableUrl = tableMenu
    ? `${tableMenu.table_code?.url}?q=${Date.now()}`
    : '';

  // const getNotifications = async () => {
  //   const res = await api.get('/restaurants/notifications');

  //   setGeneralNotifications(res.data);
  //   const fixedIds = res.data.fixed?.map((f) => f.id);
  //   const allIds = res.data.all?.map((a) => a.id);
  //   setNotiIds(fixedIds.concat(allIds));
  // };

  const loginClub = async () => {
    const response = await api.get('/restaurants/club');

    if (response.data.token) {
      setClubToken(response.data.token);
      localStorage.setItem('@clube:token', response.data.token);
    }

    if (response.data.user) {
      localStorage.setItem('@clube:user', JSON.stringify(response.data.user));
      setData((state) => {
        return {
          ...state,
          user: {
            ...state.user,
            club_key: response.data.user.key,
          },
        };
      });
    }
    setClubIsLogged(true);
  };

  useEffect(() => {
    if (user.has_clube) {
      if (!clubIsLogged) {
        loginClub();
      }
    }
  }, []);

  const [permission, setPermission] = useState(true);
  const [loadingPage, setLoadingPage] = useState(false);

  const validateUser = useCallback(async () => {
    setLoadingPage(true);
    try {
      const response = await api.get(
        `/restaurants/users/role-permission/${'OperationCurrentSessions'}`
      );
      setLoadingPage(false);
      const { can_read } = response.data.OperationCurrentSessions;

      setPermission(can_read);
    } catch (error) {
      // setPermission(false);
      // if (error?.response?.data?.payload?.user_access === 'pdv') {
      //   window.location.href = '/operation';
      // }
      setLoadingPage(false);
      toast.error('Erro ao solicitar acesso');
    }
  }, []);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  const [isModalNpsOpen, setIsModalNpsOpen] = useState(
    differenceInMonths(new Date(), new Date(user.created_at || new Date())) <=
    3 &&
    userAlreadyRate?.toString() !== 'true' &&
    differenceInHours(new Date(), new Date(modalNpsCloseTime)) > 6 &&
    user.table_limit_type === 'only-balcony'
  );
  const [rating, setRating] = useState();
  const [showCommentArea, setShowCommentArea] = useState(false);

  function toggleModalNps() {
    setIsModalNpsOpen(!isModalNpsOpen);
    setModalNpsCloseTime(new Date());
  }

  function handleSetRating(e) {
    setRating(e);
    setShowCommentArea(true);
  }

  async function handleSubmit(data) {
    try {
      await api.post('/restaurants/research-answer', {
        research_id: 101,
        value: rating,
        comment: data.comment || null,
      });

      setUserAlreadyRate(true);
      setIsModalNpsOpen(false);
    } catch (error) {
      toast.error('Erro ao enviar avaliação');
    }
  }

  // live conditional
  const [isLiveOn, setIsLiveOn] = useState(() => {
    const now = new Date();
    const day = getDay(now); // 0 = Domingo, 1 = Segunda, ..., 6 = Sábado
    const hour = getHours(now);

    // Verifica se é dia útil (segunda a sexta)
    const isWeekday = day >= 1 && day <= 5;

    // Verifica se está no horário comercial
    const isMorning = hour >= 9 && hour < 12;
    const isAfternoon = hour >= 14 && hour < 18;

    return isWeekday && (isMorning || isAfternoon);
  });

  const [isLiveTextContextOpened, setIsLiveTextContextOpened] = useState(false);

  function toggleLiveTextContext() {
    setIsLiveTextContextOpened(!isLiveTextContextOpened);
  }

  function handleGoToLive() {
    window.open('https://meet.google.com/wqr-yurp-jed');
  }

  const handleGoToBalconyMode = () => {
    const isBalconyOpen = allTables.some((table) => {
      return (
        table.table.table_type === 'balcony' && table.table.status === 'ongoing'
      );
    });
    if (isBalconyOpen && !isBalconyPinpad) {
      toast.error(
        'Mesa Balcão está aberta no momento. Por favor, feche ela para ir para o Modo Balcão.'
      );
    }
    if (!isBalconyOpen || isBalconyPinpad) {
      history.push('/balcony');
    }
  };

  // warning de novidade do contas a prazo
  const warningCreditRegisterStorage = JSON.parse(
    localStorage.getItem('@gddashboard:warningCreditRegister')
  );

  const [isNotifyOpened, setIsNotifyOpened] = useState(() => {
    if (user?.credit_register_enabled) {
      if (warningCreditRegisterStorage === null) {
        return true;
      }
      return warningCreditRegisterStorage;
    }
    return false;
  });

  function handleConfirmAndCloseNotify() {
    setIsNotifyOpened(false);
    localStorage.setItem('@gddashboard:warningCreditRegister', false);
  }

  // warning da live de suporte estar online
  const [isNotifyLiveOpened, setIsNotifyLiveOpened] = useState(() => {
    const now = new Date();
    const day = getDay(now);
    const hour = getHours(now);
    const minute = getMinutes(now);

    // Verifica se é dia útil (segunda a sexta)
    const isWeekday = day >= 1 && day <= 5;

    // Verifica se está no horário comercial
    const isMorning = hour === 9 && minute === 0;
    const isAfternoon = hour === 14 && minute === 0;

    return isWeekday && (isMorning || isAfternoon);
  });

  // warning da live de suporte noturno estar online
  const [isNotifyNightLiveOpened, setIsNotifyNightLiveOpened] = useState(() => {
    const now = new Date();
    const day = getDay(now);
    const hour = getHours(now);
    const minute = getMinutes(now);

    // Verifica se é dia útil (segunda a sexta)
    const isWeekday = day >= 1 && day <= 5;

    // Verifica se está no horário comercial
    const isEvening = hour === 18 && minute === 0;

    return isWeekday && isEvening;
  });

  // waring de novidade de plantao noturno
  const warningNightLiveSupportStorage = JSON.parse(
    localStorage.getItem('@gddashboard:warningNightLiveSupport')
  );

  const [isWarningNightLiveOpened, setIsWarningNightLiveOpened] = useState(
    () => {
      if (warningNightLiveSupportStorage === null) {
        return true;
      }
      return warningNightLiveSupportStorage;
    }
  );

  function handleConfirmAndCloseNightLiveNotify() {
    setIsWarningNightLiveOpened(false);
    localStorage.setItem('@gddashboard:warningNightLiveSupport', false);
  }

  const [isModalWppErrorOpened, setIsModalWppErrorOpened] = useState(() => {
    let rawFlag = localStorage.getItem('@gddashboard:wppErrorFlag');

    if (rawFlag === null) {
      localStorage.setItem('@gddashboard:wppErrorFlag', 'true');
      rawFlag = 'true';
    }

    const flag = rawFlag === 'true';

    const today = new Date();
    const isTodayJul28 =
      today.getDate() === 28 &&
      today.getMonth() === 6 &&
      today.getFullYear() === 2025;

    console.log('flag:', flag, 'isTodayJul28:', isTodayJul28);

    return flag && isTodayJul28;
  });

  if (user.use_new_operation) {
    return <LoadingPage />;
  }

  return (
    <>
      {/* {user.has_nfce && user.regime_tributario === '2' && <NfceModal />} */}
      {/* <ModalDeliveryCover /> */}


      <Modal
        isOpen={isModalWppErrorOpened}
        toggle={() => {
          setIsModalWppErrorOpened(false);
        }}
        size="lg"
      >
        <img
          src={BannerErrorWpp}
          style={{ width: '100%' }}
          alt="Banner info de erro do whatsapp"
        />

        <ModalFooter
          style={{
            padding: 10,
            justifyContent: 'flex-end',
          }}
        >
          <ButtonUi
            onClick={() => {
              setIsModalWppErrorOpened(false);
              localStorage.setItem('@gddashboard:wppErrorFlag', false);
            }}
          >
            Entendi
          </ButtonUi>
        </ModalFooter>
      </Modal>
      {/* <Warning type="live" isOpen={isWarningNightLiveOpened}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconNightLive style={{ width: 52 }} />
        </div>

        <div style={{ marginLeft: 16 }}>
          <p
            style={{
              fontSize: 16,
              fontWeight: 600,
              color: '#222',
            }}
          >
            Plantão tira-dúvidas noturno!
          </p>
          <p
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: '#545454',
            }}
          >
            Para aqueles que aproveitam a noite para sanar dúvidas, teremos,
            exclusivamente de 24 a 28 de março, o plantão tira-dúvidas noturno,
            das 18h às 22h! Não perca!
          </p>
        </div>
        <div style={{ width: 28 }}>
          <FaX
            onClick={() => handleConfirmAndCloseNightLiveNotify()}
            cursor="pointer"
          />
        </div>
      </Warning> */}

      {/* <Warning type="live" isOpen={isNotifyNightLiveOpened}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <LiveIcon style={{ width: 52 }} />
        </div>

        <div style={{ marginLeft: 16 }}>
          <p
            style={{
              fontSize: 16,
              fontWeight: 600,
              color: '#222',
            }}
          >
            O plantão tira-dúvidas noturno acaba de começar!
          </p>
          <p
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: '#545454',
            }}
          >
            Ao vivo de seg a sex, das 18h às 22h, exclusivamente nesta semana.
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <ButtonUi customColor="#C8131B" onClick={handleGoToLive}>
              Participar
            </ButtonUi>
          </div>
        </div>
        <div style={{ width: 28 }}>
          <FaX
            onClick={() => setIsNotifyNightLiveOpened(false)}
            cursor="pointer"
          />
        </div>
      </Warning> */}

      <Warning type="live" isOpen={isNotifyLiveOpened}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <LiveIcon style={{ width: 52 }} />
        </div>

        <div style={{ marginLeft: 16 }}>
          <p
            style={{
              fontSize: 16,
              fontWeight: 600,
              color: '#222',
            }}
          >
            O plantão tira-dúvidas acaba de começar!
          </p>
          <p
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: '#545454',
            }}
          >
            Ao vivo de seg à sex, das 9h às 12h e 14h às 18h.
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <ButtonUi customColor="#C8131B" onClick={handleGoToLive}>
              Participar
            </ButtonUi>
          </div>
        </div>
        <div style={{ width: 28 }}>
          <FaX onClick={() => setIsNotifyLiveOpened(false)} cursor="pointer" />
        </div>
      </Warning>

      {/* <Warning type="warning" isOpen={isNotifyOpened}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <WarningIcon style={{ width: 52 }} />
        </div>

        <div style={{ marginLeft: 16 }}>
          <p
            style={{
              fontSize: 16,
              fontWeight: 600,
              color: '#222',
            }}
          >
            A funcionalidade do Contas a Prazo está com novidades!
          </p>
          <span style={{ color: '#545454' }}>
            Verifique o{' '}
            <LinkStyled
              onClick={handleConfirmAndCloseNotify}
              to="/operation/credit-register"
            >
              Contas a Prazo!
            </LinkStyled>
          </span>
        </div>
        <div style={{ width: 28 }}>
          <FaX onClick={() => setIsNotifyOpened(false)} cursor="pointer" />
        </div>
      </Warning> */}

      <Modal isOpen={isModalNpsOpen} toggle={toggleModalNps} size="lg">
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <RatingContent>
              <RatingHeader>
                <span
                  style={{ fontSize: 20, fontWeight: 'bold', color: '#424242' }}
                >
                  QUEREMOS A SUA AVALIAÇÃO!
                </span>
                <span
                  style={{ fontSize: 16, color: '#424242', width: '654px' }}
                >
                  Caso você ou algum familiar/amigo venha a abrir um novo
                  estabelecimento, o quanto você estaria disposto a recomendar o
                  uso do sistema Takeat ?
                </span>
              </RatingHeader>
              <RatingBody>
                <div
                  style={{
                    width: '90%',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <span
                    style={{
                      fontSize: 14,
                      color: '#424242',
                      fontWeight: 'bold',
                    }}
                  >
                    Não Recomendo
                  </span>
                  <span
                    style={{
                      fontSize: 14,
                      color: '#424242',
                      fontWeight: 'bold',
                    }}
                  >
                    Recomendo
                  </span>
                </div>
                <div
                  style={{
                    width: '90%',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <button
                    style={{ background: '#FC1412' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    0
                  </button>
                  <button
                    style={{ background: '#FE191C' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    1
                  </button>
                  <button
                    style={{ background: '#FE3030' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    2
                  </button>
                  <button
                    style={{ background: '#FF8B00' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    3
                  </button>
                  <button
                    style={{ background: '#FF9B23' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    4
                  </button>
                  <button
                    style={{ background: '#FFCD0C' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    5
                  </button>
                  <button
                    style={{ background: '#FEC400' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    6
                  </button>
                  <button
                    style={{ background: '#80CD0D' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    7
                  </button>
                  <button
                    style={{ background: '#70B407' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    8
                  </button>
                  <button
                    style={{ background: '#00C132' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    9
                  </button>
                  <button
                    style={{ background: '#009A22' }}
                    type="button"
                    onClick={(e) => handleSetRating(e.target.innerText)}
                  >
                    10
                  </button>
                </div>

                {showCommentArea && (
                  <Textarea
                    name="comment"
                    size
                    placeHolder={
                      rating <= 5
                        ? 'Diga o que podemos melhorar para que você se sinta realmente satisfeito.'
                        : 'Nos dê um feedback para que possamos melhorar ainda mais.'
                    }
                  />
                )}
              </RatingBody>
            </RatingContent>
          </ModalBody>
          <ModalFooter>
            <div
              style={{
                width: '92%',
                marginLeft: 20,
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <div style={{ display: 'flex' }}>
                <PersonalButton
                  message="Avaliar depois"
                  color="#FF2C3A"
                  style={{ marginRight: 8 }}
                  type="button"
                  onClick={toggleModalNps}
                />
                <PersonalButton
                  message="Enviar"
                  color="#2EC9B7"
                  type="submit"
                  disabled={!rating}
                />
              </div>
            </div>
          </ModalFooter>
        </Form>
      </Modal>

      {/**
       * Whatsapp Reconnect Modal, used when the user is logged in and the
       * whatsapp connection is lost.
       */}
      <WhatsappConnectionModal />

      <Wrapper>
        <NewHeader signOut={signOut} />
        <OperationArea>
          {!permission ? (
            <div
              style={{
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'flex-start',
                marginTop: '10%',
              }}
            >
              <PermissionErrorContainer loading={loadingPage} />
            </div>
          ) : (
            <>
              <TablesCardArea>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                  }}
                >
                  <div
                    style={{
                      position: 'relative',
                      display: 'flex',
                      gap: 10,
                    }}
                  >
                    <Tabs
                      tabs={[
                        user?.use_tablet_with_qr_code ? 'Comandas' : 'Mesas',
                        'Comandas Offline',
                      ]}
                      selected={activeTab}
                      counter={[null, null]}
                      onChangeTab={(e) => setActiveTab(e)}
                      mediaQueries={[
                        {
                          maxWidth: 1110,
                          styles: `font-size: 12px;`,
                        },
                      ]}
                    />

                    {user?.has_balcony && (
                      <div style={{ paddingTop: 5 }}>
                        {/* <BalconyLink to="/balcony">Modo Balcão</BalconyLink> */}
                        <BalconyLink onClick={() => handleGoToBalconyMode()}>
                          Modo Balcão
                        </BalconyLink>
                      </div>
                    )}
                  </div>

                  <div style={{ position: 'relative' }}>
                    {isLiveOn ? (
                      <LiveOn
                        onClick={toggleLiveTextContext}
                        style={{ cursor: 'pointer' }}
                      />
                    ) : (
                      <LiveOff
                        onClick={toggleLiveTextContext}
                        style={{ cursor: 'pointer' }}
                      />
                    )}

                    {isLiveOn && isLiveTextContextOpened ? (
                      <LiveTextContent>
                        <FaX
                          onClick={toggleLiveTextContext}
                          color="#f10d27"
                          cursor="pointer"
                          style={{ float: 'right' }}
                        />
                        {/* <p>
                          Esclarecemos as suas dúvidas em tempo real. Junte-se
                          ao nosso Plantão Tira Dúvidas!{' '}
                        </p>

                        <p style={{ fontSize: 14, marginTop: 10 }}>
                          {' '}
                          Programação: 9h às 12h e 14h às 18h de segunda à
                          sexta.
                        </p>

                        <Button
                          title="Ir para o plantão tira dúvidas"
                          containerStyles={{ width: '100%' }}
                          onClick={handleGoToLive}
                        /> */}
                        <p>
                          Nosso plantão tira dúvidas está temporariamente fora do ar, retornaremos assim que possível.
                        </p>
                        <Button title='Voltaremos em breve' disabled />
                      </LiveTextContent>

                    ) : (
                      isLiveTextContextOpened && (
                        <LiveTextContent>
                          <FaX
                            onClick={toggleLiveTextContext}
                            color="#f10d27"
                            cursor="pointer"
                            style={{ float: 'right' }}
                          />
                          <p>
                            O plantão tira dúvidas é um atendimento coletivo,
                            onde um de nossos especialistas fica de prontidão
                            via Google Meet, com o intuito de sanar suas dúvidas
                            quanto ao sistema.
                          </p>
                          <p>
                            Estamos disponíveis de 9h às 12h e 14h às 18h de
                            segunda à sexta. Traga suas dúvidas!
                          </p>
                        </LiveTextContent>
                      )
                    )}
                  </div>
                </div>

                <TablesContainer isFirst={activeTab === 0}>
                  <TablesOperation
                    activeTab={activeTab}
                    minimalSessions={
                      tablesFilteredSearch.length > 0
                        ? tablesFilteredSearch
                        : minimalSessions
                    }
                    getMinimalSessions={getMinimalSessions}
                    loading={loading}
                    // payments={payments}
                    // paymentMethods={paymentMethods}
                    setMinimalSessions={setMinimalSessions}
                    inicialDate={inicialDate}
                    finalDate={finalDate}
                    getTablesAvailable={getTablesAvailable}
                    tablesAvailable={
                      allTablesAvailable.length > 0
                        ? allTablesAvailable
                        : tablesAvailable
                    }
                    updateOpeninBoxOperation={updateOpeninBoxOperation}
                    orderByTableDate={orderByTableDate}
                    handleSearchInputTables={handleSearchInputTables}
                    setAllTablesAvailable={setAllTablesAvailable}
                    setTablesFilteredSearch={setTablesFilteredSearch}
                    setCount={setCount}
                    hasFilteredSessions={tablesFilteredSearch.length > 0}
                    ref={tablesRef}
                    handleUpdate={handleUpdate}
                    sessionsInCache={sessionsInCache}
                  />
                </TablesContainer>
              </TablesCardArea>
              <OrdersCardArea>
                <OrdersOperation
                  sessions={minimalSessions}
                  loading={loading}
                  setSessions={setSessions}
                  inicialDate={inicialDate}
                  finalDate={finalDate}
                  orderByTableDate={orderByTableDate}
                  orderByTableNumber={orderByTableNumber}
                  pendingBaskets={pendingBaskets}
                  acceptedBaskets={acceptedBaskets}
                  canceledBaskets={canceledBaskets}
                  finishedBaskets={finishedBaskets}
                  handleItemFinished={handleItemFinished}
                  handleCancelItem={handleCancelItem}
                  handlePrintItem={handlePrintItem}
                  tableBills={closingTableBills}
                  printQueueTable={printQueueTable}
                  individualBills={closingIndividualBills}
                  printTableBill={printTableBill}
                  printIndividualBill={printIndividualBill}
                  getTablesAvailable={getTablesAvailable}
                  ref={orderOperationRef}
                  minimalSessions={minimalSessions}
                  getMinimalSessions={getMinimalSessions}
                  setAllTablesAvailable={setAllTablesAvailable}
                  setTablesFilteredSearch={setTablesFilteredSearch}
                  setInputValueTables={setInputValueTables}
                  waiterTickets={waiterTickets}
                  sessionsInCache={sessionsInCache}
                />
              </OrdersCardArea>
            </>
          )}

          <Modal isOpen={isModalQrcodeOpened} toggle={toggleModalQrcode}>
            <ModalHeader>
              <strong style={{ fontSize: 16 }}>Cardápio Digital</strong>
            </ModalHeader>
            <ModalBody>
              <p>
                Compartilhe seu Cardápio em suas redes sociais e Whatsapp
                clicando no ícone "Copiar" <FiCopy color="FF2C3A" /> . Salve a
                imagem ou copie o link. Aproveite!
              </p>

              <div
                style={{
                  marginBottom: '16px',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',

                    alignItems: 'center',

                    width: '100%',
                  }}
                >
                  <strong>Cardápio Digital (SOMENTE VISUALIZAÇÃO)</strong>

                  <FiCopy
                    color="FF2C3A"
                    onClick={copyUrlCode}
                    size={18}
                    style={{ cursor: 'pointer', marginLeft: 8 }}
                    title="Copiar link"
                  />

                  {/* 
                <SaveButton type="button" onClick={copyUrlCode}>
                  {codeCopyed ? 'Copiado' : 'Copiar'}
                </SaveButton> */}
                </div>
                {tableMenu && (
                  <input
                    id="url-qrcode"
                    ref={inputRef}
                    value={`https://cardapio.takeat.app/${user.name}`}
                    type="Text"
                    style={{ border: 'none', width: '80%' }}
                  />
                )}
              </div>

              {(user?.delivery_info?.is_delivery_allowed ||
                user?.delivery_info?.is_withdrawal_allowed) && (
                  <div
                    style={{
                      marginBottom: '16px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',

                        width: '100%',
                      }}
                    >
                      <strong>Cardápio Digital (PEDIDOS)</strong>
                      <FiCopy
                        color="FF2C3A"
                        onClick={copyDeliveryUrlCode}
                        size={18}
                        style={{ cursor: 'pointer', marginLeft: 8 }}
                        title="Copiar link"
                      />
                    </div>

                    <input
                      id="url-delivery"
                      ref={inputDeliveryRef}
                      value={`https://pedido.takeat.app/${user.name}`}
                      type="Text"
                      style={{ border: 'none', width: '80%' }}
                    />
                  </div>
                )}

              {tableMenu && (
                <>
                  <ImgToPrint
                    ref={imgRef}
                    imgSrc={tableUrl}
                    tableMenu={tableMenu}
                  />

                  <SaveButton type="button" onClick={downloadPng}>
                    Baixar Imagem
                  </SaveButton>
                </>
              )}
            </ModalBody>
          </Modal>
          <Modal
            isOpen={modalCancelOrderIsOpened}
            toggle={toggleModalCancelOrder}
          >
            <Form onSubmit={handleCancelItemModal} ref={cancelForm}>
              <ModalBody>
                <Input
                  name="order_cancel_password"
                  label="Senha de cancelamento"
                  type="password"
                />
                <Input name="cancel_reason" label="Justificativa" />
              </ModalBody>
              <ModalFooter>
                <ButtonDefault
                  message="Confirmar"
                  type="submit"
                  disabled={loadingCancelItem}
                />
              </ModalFooter>
            </Form>
          </Modal>

          <Modal isOpen={modalPix} toggle={toggleModalPix}>
            <ModalBody>
              <div style={{ margin: 'auto', textAlign: 'center' }}>
                <img
                  src={pixLogo}
                  style={{ width: '45%', heigth: 'auto' }}
                  alt="logotipo do PIX"
                />
                <h5 style={{ marginTop: 10 }}>Novos Pagamentos Online</h5>
              </div>
              <Table borderless>
                <thead>
                  <tr>
                    <th>Mesa</th>
                    <th>Tipo</th>
                    <th>Telefone</th>
                    <th>Valor</th>
                    <th>Horário</th>
                  </tr>
                </thead>
                <tbody>
                  {localPixToShow?.map((pix) => (
                    <tr>
                      <td>
                        {pix?.table_session.table.table_type === 'delivery'
                          ? 'Delivery'
                          : pix?.table_session.table.table_number}
                      </td>
                      <td>{pix?.individual_bill_id ? 'Individual' : 'Mesa'}</td>
                      <td>{pix?.phone}</td>
                      <td>R${pix?.total}</td>
                      <td>
                        {pix?.payed_at && formatCompleteDate(pix?.payed_at)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </ModalBody>
            <ModalFooter>
              <ButtonDefault
                message="Ok"
                onClick={() => handlePixNotification()}
              />
            </ModalFooter>
          </Modal>
          <TakeatModal
            open={isModalSystemBloquedOpen}
            style={{
              width: 'fit-content',
              height: 'fit-content',
              padding: '16px',
            }}
          >
            <TakeatModalHeader>
              <AlertIcon />
            </TakeatModalHeader>
            <TakeatModalBody>
              <h2>Atenção</h2>
              <p>
                O sistema está bloqueado por falta de pagamento. Efetue o
                pagamento para voltar a utilizar.
              </p>
            </TakeatModalBody>
            <TakeatModalFooter>
              <TakeatButton
                style={{
                  backgroundColor: '#FFB32F',
                }}
                onClick={handleOpenAsaas}
              >
                Abrir fatura
              </TakeatButton>
            </TakeatModalFooter>
          </TakeatModal>
          {planType === 'AI_AGENTS' && wppAlert.currentWppAlert?.type && (
            <WaiterAlertWppDesignContainerFixedPosition>
              <WaiterAlertWppDesign {...wppAlert} />
            </WaiterAlertWppDesignContainerFixedPosition>
          )}
          <WaiterHelpModal />
          {/* <ModalUpdateZoop /> */}
        </OperationArea>
      </Wrapper>
    </>
  );
}

export default Operation;
